const isSimpleType = (variant) => {
    return variant === "radio-simple" || variant === "checkbox-simple";
};
const isSlotType = (variant) => {
    return variant === "radio-slot" || variant === "checkbox-slot";
};
const isRadioType = (variant) => {
    return variant === "radio-simple" || variant === "radio-slot";
};
const isCheckboxType = (variant) => {
    return variant === "checkbox-simple" || variant === "checkbox-slot";
};

export { isCheckboxType, isRadioType, isSimpleType, isSlotType };
